import React from 'react';
import PropTypes from 'prop-types';
import { FormToggle } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import { Quote } from '../../../quotes/quote';
//import './ReviewQuoteExpeditedShipping.scss';

export default class ReviewQuoteExpeditedShipping extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(Quote).isRequired,
    onUpdate: PropTypes.func.isRequired,
  };

  updateValue = (property, value) => {
    const copy = this.props.quote.clone();
    copy[property] = value;
    if (property === 'expeditedShippingRequested') {
      copy.expeditedShippingNotes = '';
    }
    this.props.onUpdate(copy);
  };

  render() {
    const { quote } = this.props;
    if (!quote.step1.dealerBranchSummary.isExpeditedShippingEnabled)
      return null;

    return (
      <div className="card-deck expedited-shipping">
        <div className="card mb-4 box-shadow">
          <div className="alert alert-success">
            <h6 className="card-title text-center">Expedited Shipping</h6>
            <div className="expedited-question">
              <FormToggle
                checked={quote.expeditedShippingRequested}
                label="Request custom pricing for expedited shipping?"
                onChange={(checked) =>
                  this.updateValue('expeditedShippingRequested', checked)
                }
              />
            </div>
            {quote.expeditedShippingRequested && (
              <div className="expedited-notes">
                <FormInput
                  label=""
                  type="textarea"
                  placeholder="Please provide details about the products that you would like expedited shipping on, including your required delivery date"
                  id="expeditedShippingNotes"
                  value={quote.expeditedShippingNotes}
                  onChange={(e) =>
                    this.updateValue('expeditedShippingNotes', e.target.value)
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
